import { useContext, useMemo } from 'react';

import { dataManagerContext } from './dataManagerContext';
import { Replication } from './Replication';

export function useReplication(): Replication | undefined {
  const { state } = useContext(dataManagerContext);
  return useMemo(() => state.replication, [state]);
}
